import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from '@/pages/Landing';

const AdminApp = lazy(() => import('@/admin/AdminApp'));
const PressPage = lazy(() => import('@/pages/PressPage'));
const PrivacyPage = lazy(() => import('@/pages/PrivacyPage'));
const TermsPage = lazy(() => import('@/pages/TermsPage'));

const legalFallback = <div style={{ minHeight: '100vh', background: '#070b12' }} />;

export default function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', background: '#070b12' }} />}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route
          path="/press"
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', background: '#070b12' }} />}>
              <PressPage />
            </Suspense>
          }
        />
        <Route
          path="/legal/privacy"
          element={
            <Suspense fallback={legalFallback}>
              <PrivacyPage />
            </Suspense>
          }
        />
        <Route
          path="/legal/terms"
          element={
            <Suspense fallback={legalFallback}>
              <TermsPage />
            </Suspense>
          }
        />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
